import { useCallback, useEffect, useState } from 'react';
import { coursesApi } from '../../courses/services/coursesApi';

/**
 * Hook to fetch learner insights data
 */
export function useInsights() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchInsights = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await coursesApi.fetchInsights({ auth: true });
      setData(response);
    } catch (err) {
      console.error('[useInsights] Failed to fetch insights:', err);
      setError(err?.message || 'Failed to load insights');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchInsights();
  }, [fetchInsights]);

  const refetch = useCallback(() => {
    fetchInsights();
  }, [fetchInsights]);

  return {
    data,
    isLoading,
    error,
    refetch,
  };
}
